import { render, staticRenderFns } from "./app.vue?vue&type=template&id=58b906dc&scoped=true&"
import script from "./app.vue?vue&type=script&lang=ts&"
export * from "./app.vue?vue&type=script&lang=ts&"
import style0 from "./app.vue?vue&type=style&index=0&id=58b906dc&scoped=true&lang=css&"
import style1 from "@/assets/css/muuq-base.css?vue&type=style&index=1&lang=css&"
import style2 from "@/assets/css/muuq-fonts/style.css?vue&type=style&index=2&lang=css&"
import style3 from "@/assets/css/front.css?vue&type=style&index=3&lang=css&"
import style4 from "@/assets/css/flexslider/flexslider.css?vue&type=style&index=4&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b906dc",
  null
  
)

export default component.exports